import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureGetMembershipVehicle, successGetMembershipVehicle } from "./MembershipVehicleSlicer";
import { IMembershipVehicleList } from "../../../Pages/MembershipVehicle/IMembershipVehicle";
import { PayloadAction } from "@reduxjs/toolkit";
import { failureAddMembershipVehicle, successAddMembershipVehicle } from "./AddMembershipVehicleSlicer";
import { failureUpdateMembershipVehicle, successUpdateMembershipVehicle } from "./UpdateMembershipVehicleSlicer";
import { failureDeleteMembershipVehicle, successDeleteMembershipVehicle } from "./DeleteMembershipVehicleSlice";
import { act } from '@testing-library/react';

const MembershipVehicleApi = (action: any) => {
  const { page, pageSize, locationId, key, sortField, sortOrder } =
    action.payload || {};
  const query = new URLSearchParams();
  if (locationId) query.append("locationId", locationId);

  if (page !== undefined && pageSize !== undefined) {
    query.append("skip", String(page * pageSize)); // ✅ correct
    query.append("limit", String(pageSize));
  }
  if (sortField) query.append("sortField", sortField);
  if (sortOrder) query.append("sortOrder", sortOrder);
  console.log("arer", action.payload);
  let url: any;

  if (key) {
    // list endpoint with pagination + optional locationId
    url = `/userDesignations/vehicle/list?${query.toString()}`;
  } else {
    // single endpoint (no pagination)
    url = `/userDesignations/vehicle/${action.payload}`;
  }
  return api.get(url);
};

export function* MembershipVehicleCall(action: PayloadAction<IMembershipVehicleList>) {
  try {
    const response: AxiosResponse = yield call(MembershipVehicleApi,action);
    yield put(successGetMembershipVehicle(response.data));
  } catch (error) {
    yield put(failureGetMembershipVehicle(error));
  }
}

// add MembershipVehicle
const AddMembershipVehicleApi = (action: PayloadAction<IMembershipVehicleList>) => {
  return api.post('/userDesignations/vehicle/create', action.payload)
};

export function* AddMembershipVehicleCall(action: PayloadAction<IMembershipVehicleList>) {
  try {
    const response: AxiosResponse = yield call(AddMembershipVehicleApi, action);
    yield put(successAddMembershipVehicle(response.data));
  } catch (error) {
    yield put(failureAddMembershipVehicle(error));
  }
}

// update MembershipVehicle
const UpdateMembershipVehicleApi = (action: PayloadAction<IMembershipVehicleList>) => {
  // const formData = new FormData();

  // Object.entries(action.payload).forEach(([key, value]) => {
  //   formData.append(key, value);
  // });
  const url = `/userDesignations/vehicle/update/${action.payload.id}`;

  return api.patch(url, action.payload);
};

export function* UpdateMembershipVehicleCall(action: PayloadAction<IMembershipVehicleList>) {
  try {
    const response: AxiosResponse = yield call(UpdateMembershipVehicleApi, action);
    yield put(successUpdateMembershipVehicle(response.data));
  } catch (error) {
    yield put(failureUpdateMembershipVehicle(error));
  }
}

// delete MembershipVehicle
const DeleteMembershipVehicleApi = (action: PayloadAction<number>) => {
  return api.delete(`/userDesignations/vehicle/${action.payload}`);
};
export function* DeleteMembershipVehicleCall(action: PayloadAction<number>) {
  try {
    const response: AxiosResponse = yield call(DeleteMembershipVehicleApi, action);
    yield put(successDeleteMembershipVehicle(response.data));
  } catch (error) {
    yield put(failureDeleteMembershipVehicle(error));
  }
}
